








import AgroIcons from '@/components/agroIcons/AgroIcons.vue';
import CropIcons from '@/utils/iconCropTypes';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { GaiiaArch } from '@/constants/gaiia-arch';

 @Component({
  name: 'AnalysesBadge',
  components: { AgroIcons },
 })
export default class AnalysesBadge extends Vue {
  @Prop(String)
  private readonly cropType!: string;

  @Prop({ type: String, default: GaiiaArch.THEMIS })
  private readonly yieldestSource!: String;

  @Prop({ type: String, default: GaiiaArch.THEMIS })
  private readonly cropIdSource!: String;

  @Prop(Number)
  private readonly year!: number;

  @Prop(Object)
  private readonly route!: RawLocation;

  @Prop({ type: String, default: 'PROCESSING' })
  private readonly status!: string;

  
  get safeYieldestSource() {
    return this.yieldestSource == null ||  this.yieldestSource == '' ? GaiiaArch.THEMIS : this.yieldestSource;
  }

  get safeCropIdSource() {
    return this.cropIdSource == null ||  this.cropIdSource == '' ? GaiiaArch.THEMIS : this.cropIdSource;
  }

  private get colorByArchs() {
    if (this.safeYieldestSource == GaiiaArch.THEMIS && this.safeCropIdSource == GaiiaArch.THEMIS) {
      return 'color: white'
    }

    if (this.safeYieldestSource == GaiiaArch.ALCYONE && this.safeCropIdSource == GaiiaArch.IRIS) {
      return 'color: #c3f7f5; font-weight: 700'
    }

    return 'color: #b8b7b6; font-weight: 700'
  }

  private get cropIconName() {
    return CropIcons.fromText(this.cropType);
  }
}
